import React from 'react';
import { Tooltip, TooltipToggle } from 'telia-front-react';
import { observer } from 'mobx-react';
import { Item } from './types';

interface PacketGiftTooltipProps {
  item: Item;
}

const PacketGiftTooltip: React.FC<PacketGiftTooltipProps> = (props) => {
  const {
    giftTooltip: { beforeTooltip, tooltipTogglerText, afterTooltip, afterTooltipBold, tooltipImage, tooltopOpenText, tooltopOpenTextBold },
    index
  } = props.item;

  return (
    <React.Fragment>
      {beforeTooltip}
      <Tooltip
        referenceElement={
          <TooltipToggle id={`gifttip-${index || '1'}`} className="text-bold">
            {tooltipTogglerText}
          </TooltipToggle>
        }
      >
        <div className="text text-center">
          <img
            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            alt="gift"
            data-srcset={tooltipImage}
            className="lazyload img-responsive"
            width="360"
            data-sizes="auto"
          />
          <p>
            {tooltopOpenText}
            <strong>{tooltopOpenTextBold}</strong>
          </p>
        </div>
      </Tooltip>
      {afterTooltip}
      <div>
        <strong>{afterTooltipBold}</strong>
      </div>
    </React.Fragment>
  );
};

export default observer(PacketGiftTooltip);
